/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SkuProductResVo } from './SkuProductResVo';
import {
    SkuProductResVoFromJSON,
    SkuProductResVoFromJSONTyped,
    SkuProductResVoToJSON,
    SkuProductResVoToJSONTyped,
} from './SkuProductResVo';

/**
 * 
 * @export
 * @interface ResponseSkuProductResVo
 */
export interface ResponseSkuProductResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseSkuProductResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseSkuProductResVo
     */
    message?: string;
    /**
     * 
     * @type {SkuProductResVo}
     * @memberof ResponseSkuProductResVo
     */
    data?: SkuProductResVo;
}

/**
 * Check if a given object implements the ResponseSkuProductResVo interface.
 */
export function instanceOfResponseSkuProductResVo(value: object): value is ResponseSkuProductResVo {
    return true;
}

export function ResponseSkuProductResVoFromJSON(json: any): ResponseSkuProductResVo {
    return ResponseSkuProductResVoFromJSONTyped(json, false);
}

export function ResponseSkuProductResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseSkuProductResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : SkuProductResVoFromJSON(json['data']),
    };
}

export function ResponseSkuProductResVoToJSON(json: any): ResponseSkuProductResVo {
    return ResponseSkuProductResVoToJSONTyped(json, false);
}

export function ResponseSkuProductResVoToJSONTyped(value?: ResponseSkuProductResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': SkuProductResVoToJSON(value['data']),
    };
}

